import { useState, useEffect } from "react";
import { Calculator } from "lucide-react";
import { Button } from "@/components/ui/button";
import CorporateCalculatorModal from "@/components/CorporateCalculatorModal";
import { useTranslation } from "react-i18next";
import guestlyLogoMark from "@/assets/guestly-logo-mark.svg";

const StickyCalculatorHeader = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition > 200);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div
        className={`fixed top-0 left-0 right-0 z-40 bg-background/95 backdrop-blur-sm border-b border-border transition-all duration-500 ease-out ${
          isVisible ? "translate-y-0 opacity-100 shadow-md" : "-translate-y-full opacity-0"
        }`}
      >
        <div className="container mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-14 sm:h-16 gap-4">
            {/* Logo */}
            <div className="flex items-center gap-6 sm:gap-8">
              <img 
                src={guestlyLogoMark} 
                alt="Guestly Homes logo - Corporate housing and furnished apartments" 
                className="h-8 sm:h-10 w-auto"
              />
              <span className="text-base sm:text-lg font-bold text-foreground hidden md:block">
                {t('stickyHeader.cta')}
              </span>
              <span className="text-sm font-bold text-foreground md:hidden">
                {t('stickyHeader.ctaShort')}
              </span>
            </div>
            <Button
              onClick={() => setIsModalOpen(true)}
              size="sm"
            >
              <Calculator className="h-4 w-4 sm:mr-2" />
              <span className="hidden sm:inline">{t('stickyHeader.button')}</span>
              <span className="sm:hidden">{t('stickyHeader.buttonShort')}</span>
            </Button>
          </div>
        </div>
      </div>

      <CorporateCalculatorModal
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
      />
    </>
  );
};

export default StickyCalculatorHeader;
